import { ReactNode, TableHTMLAttributes, ThHTMLAttributes, TdHTMLAttributes } from 'react';

export interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  children: ReactNode;
}

export function Table({ className = '', children, ...rest }: TableProps) {
  return (
    <table className={`ds-tbl ${className}`.trim()} {...rest}>
      {children}
    </table>
  );
}

export type TableAlign = 'left' | 'right' | 'center';

export interface ThProps extends ThHTMLAttributes<HTMLTableCellElement> {
  align?: TableAlign;
}

export function Th({ align = 'left', className = '', children, ...rest }: ThProps) {
  const alignCls = align === 'right' ? 'ds-r' : align === 'center' ? 'ds-c' : '';
  return (
    <th className={[alignCls, className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </th>
  );
}

export interface TdProps extends TdHTMLAttributes<HTMLTableCellElement> {
  align?: TableAlign;
  mono?: boolean;
}

export function Td({ align = 'left', mono = false, className = '', children, ...rest }: TdProps) {
  const alignCls = align === 'right' ? 'ds-r' : align === 'center' ? 'ds-c' : '';
  const cls = [alignCls, mono ? 'ds-id' : '', className].filter(Boolean).join(' ');
  return (
    <td className={cls} {...rest}>
      {children}
    </td>
  );
}

export interface TrProps extends React.HTMLAttributes<HTMLTableRowElement> {
  selected?: boolean;
}

export function Tr({ selected = false, className = '', children, ...rest }: TrProps) {
  const cls = [selected ? 'ds-tr-selected' : '', className].filter(Boolean).join(' ');
  return (
    <tr className={cls} {...rest}>
      {children}
    </tr>
  );
}

export default Table;
